import { render, staticRenderFns } from "./SocialMediaSharing.vue?vue&type=template&id=6647b3d2&"
import script from "./SocialMediaSharing.vue?vue&type=script&lang=js&"
export * from "./SocialMediaSharing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports